import React from 'react';
import { MarkDownContent as OrigMarkDownContent, MarkDownContentProps } from '../themed/MarkDownContent';
import { Editable, TextLookupProps } from './Editable';

export interface EditableMarkDownContentProps extends MarkDownContentProps, TextLookupProps {}

export const MarkDownContent = (props: EditableMarkDownContentProps) => <Editable {...props} render={OrigMarkDownContent} />;
